import { motion } from "framer-motion";

import RaindropDivider from "../../ui-components/raindrop-divider/raindrop-divider";
import IconTick from "../../ui-components/icon-tick/icon-tick";

import IconCross from "../../ui-components/icon-cross/icon-cross";

import MembershipTitle from "../membership-title/membership-title.tsx";

const MembershipCardItem = ({
  text = "Example item",
  isIncluded = true,
  isSapphire = true,
}) => {
  let textColor = "text-color-raindrop-minor-again";
  let fontSize = "font-normal";
  let lineThrough = "";
  let icon = <IconCross className={`h-5 fill-color-raindrop-minor-again`} />;

  let tickColor = "fill-color-version-emerald";
  if (isSapphire) {
    tickColor = "fill-color-version-sapphire";
  }

  if (isIncluded) {
    lineThrough = "";
    fontSize = "font-medium";
    textColor = "text-white";
    icon = <IconTick className={`h-5 ${tickColor}`} />;
  }

  return (
    <div className="flex flex-row items-center gap-4">
      <div className="flex items-center justify-center w-5">{icon}</div>
      <div className={`${textColor} ${lineThrough} text-sm ${fontSize}`}>
        {text}
      </div>
    </div>
  );
};

const MembershipCard = ({
  isRaindropPlusship,
  onClick,
  selected,
  isClickable = true,
}) => {
  let backgroundColor = "bg-color-dark-background-secondary";
  let borderColor = "border-color-dark-border-tertiary";
  let hover = "md:hover:scale-95";

  if (selected && isRaindropPlusship) {
    borderColor = "border-color-version-sapphire";
    backgroundColor = "bg-gradient-to-br from-black via-black to-blue-950";
  }

  if (selected && !isRaindropPlusship) {
    borderColor = "border-color-version-emerald";
    backgroundColor = "bg-gradient-to-br from-black via-black to-green-950";
  }

  if (!isClickable) {
    hover = "";
  }

  return (
    <motion.div
      id={"membership-card"}
      layout={true}
      onClick={onClick}
      className={`flex flex-col border w-full rounded-lg p-4 text-left gap-4 min-h-[220px] ${backgroundColor} max-w-md ${hover} ${borderColor} transition-all`}
    >
      <MembershipTitle isRaindropPlusship={isRaindropPlusship} />

      <RaindropDivider />
      <div id={`card-body`} className="flex flex-col gap-4">
        <div className={"flex flex-col gap-1"}>
          <MembershipCardItem
            isIncluded={isRaindropPlusship}
            text={"Unlimited share cards, badges and all future features"}
            isSapphire={isRaindropPlusship}
          />
          <MembershipCardItem
            isIncluded={isRaindropPlusship}
            text={"Support our work with 10% of your contribution"}
            isSapphire={isRaindropPlusship}
          />
          <MembershipCardItem
            isIncluded={!isRaindropPlusship}
            text={"Limited to three organisations"}
            isSapphire={isRaindropPlusship}
          />
          <MembershipCardItem
            isIncluded={!isRaindropPlusship}
            text={"Advertisements"}
            isSapphire={isRaindropPlusship}
          />
        </div>
      </div>
    </motion.div>
  );
};

export default MembershipCard;
